<template>
  <v-row>
    <v-col>
      <div v-if="showCard">
        <CardsView
          :items="modelsLiquidations"
          :openDialog="openDialog"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <div v-if="!showCard">
        <TableWithSearch
          :items="modelsLiquidations"
          :title="title"
          :headers="allHeaders"
          :openDialog="openDialog"
          @headersUpdated="updateHeaders"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <v-dialog
        v-model="open"
        :max-width="maxWidth[0]"
        hide-overlay
        persistent
        @keydown.esc="reset(false)"
      >
        <Form
          :items="dataInputs"
          @save="saveForm"
          @cancel="reset"
          :maxWidth="maxWidth[0]"
          :mode="mode"
          :show="true"
          :itemsSelect="dataSelects"
          :itemsHours="dataInputsHours"
        />
      </v-dialog>
      <my-dialog 
        @closeEditDialog="closeEditDialog"
        :dialog="showModelRelation"
      ></my-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import costCenters from "@/store/centrosDeCosto/costCenters";
import clocks from "@/store/centrosDeCosto/clocks";
import date from "@/store/common/date";
import concepts from "@/store/conceptos/concepts";
import modelsLiquidation from "@/store/modelosDeLiquidacion/modelsLiquidation";
import CardsView from "@/components/Complement/CardsView.vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import ToolbarTitles from "@/components/Complement/ToolbarTitles.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import Form from "@/components/Complement/Form.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import MyDialog from "./relations/modelLiquidation.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    TableWithSearch,
    CardsView,
    ToolbarTitles,
    ButtonsCardList,
    Form,
    DeleteDialog,
    Snackbar,
    Loader,
    MyDialog,
  },
  props: {
    showCard: Boolean,
  },
  data() {
    return {
      meses: [
        { name: "En curso", value: "E" },
        { name: "Anterior", value: "A" },
      ],
      frecuencias: [
        { name: "Mensual", value: "M" },
        { name: "Fija", value: "F" },
      ],

      title: "",
      titleTable: "ModelosDeLiquidacion",
      titleDelete: this.$tc("modelsLiquidations.toModelLiquidation"),
      isLoading: true,
      maxWidth: ["500px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      itemId: null,
      showModelRelation: false,
      dataInputs: [
        {
          name: "name",
          label: "Nombre de la liquidación",
          data: "",
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              v.length <= 50 || this.$t("validation.maxChart", { max: 50 }),
          ],
        },
        {
          name: "diaInicio",
          label: "Día de inicio",
          data: 1,
          type: "number",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              (v >= 1 && v <= 31) ||
              this.$t("validation.maxChart.range", { min: 1, max: 31 }),
          ],
        },
      ],
      dataInputsHours: [
        {
          name: "topeMaxHExtras",
          label: "Tope de horas extras (hh:mm)",
          data: "",
          rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
        },
      ],

      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Frecuencia",
          value: "frecuencia",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Dia de inicio",
          value: "diaInicio",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Mes",
          value: "mes",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Activa",
          value: "activa",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
    };
  },
  async mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (configTable.state.colums.length === 0 || configTable.state.colums.length !== this.headers.length ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    try {
      await Promise.all([
        concepts.dispatch("getConcepts"),
        concepts.dispatch("getLiquidationModels"),
        clocks.dispatch("getClocks"),
        costCenters.dispatch("getCostCenters"),
        modelsLiquidation.dispatch("getLiquidationModels"),
      ]);

      this.isLoading = false;
    } catch (error) {
      console.error(error);
    }
  },

  computed: {
    allHeaders() {
      return Array.isArray(configTable.state?.colums)
        ? configTable.state.colums
        : [];
    },
    modelsLiquidations() {
      return modelsLiquidation.state.modelsLiquidations;
    },
    costCenters() {
      return costCenters.state.costCenters;
    },
    clocks() {
      return clocks.state.clocks;
    },
    padding() {
      return costCenters.state.paddingNav;
    },
    salaries() {
      return concepts.state.salaries;
    },
    liquidations() {
      return concepts.state.liquidations;
    },

    dataSelects() {
      return [
        {
          name: "meses",
          label: "Meses",
          data: "E",
          items: this.meses,
          itemsValue: "value",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          icon: "",
        },
        {
          name: "frecuencia",
          label: "Frecuencia",
          data: "F",
          items: this.frecuencias,
          itemsValue: "value",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          icon: "mdi-pencil",
        },
      ];
    },
    mode: {
      get() {
        return modelsLiquidation.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return modelsLiquidation.state.open;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return modelsLiquidation.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  methods: {
    async refreshItems() {
      await modelsLiquidation.dispatch("getLiquidationModels");
    },
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (columnsToSave === undefined || this.allHeaders.length !== this.headers.length  || columnsToSave.length === 0) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    addModelLiquidation(form) {
      form.topeMaxHExtras = this.convertToMinutes(form.topeMaxHExtras);
      modelsLiquidation.commit("setNew", form);
      modelsLiquidation
        .dispatch("add")
        .then(() => {
          this.showAlert(
            this.$tc("costCenter.addCostCenterSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(this.$tc("costCenter.addCostCenterError"), "#ff8d58");
        });
      this.reset(false);
    },

    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    saveForm(items) {
      switch (this.typeForm) {
        case "add":
          this.addModelLiquidation(items);
          break;
        case "edit":
          this.editModelLiquidation(items);
          break;
        default:
          break;
      }
    },

    resetDate() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },

    reset(value) {
      this.resetDate();
      modelsLiquidation.commit("setOpen", value);
      this.dataInputs.forEach((item) => {
        item.data = "";
      });
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const day = String(date.getUTCDate()).padStart(2, "0");

      return `${day}-${month}-${year}`;
    },
    async setEdit(item) {
      await modelsLiquidation.dispatch("getLiquidationModelId", this.itemId);
    },
    convertToMinutes(value, dayValue) {
      const [hours, minutes] = value.split(":");
      const hoursInt = parseInt(hours, 10);
      const minutesInt = parseInt(minutes, 10);
      let totalMinutes = hoursInt * 60 + minutesInt;
      if (dayValue === "0") {
        totalMinutes -= 1440;
      } else if (dayValue === "2") {
        totalMinutes += 1440;
      }
      return totalMinutes;
    },

    async openDialog(type, item) {
      this.typeForm = type;
      switch (this.typeForm) {
        case "add":
          modelsLiquidation.commit(
            "setMode",
            this.$tc("modelsLiquidations.addModelLiquidation")
          );
          modelsLiquidation.commit("setOpen", true);
          break;
        case "edit":
          this.itemId = item.liqmodelId;
          modelsLiquidation.commit(
            "setMode",
            this.$tc("modelsLiquidations.editModelLiquidation")
          );

          await this.setEdit(item);
          this.openEditDialog();

          break;
        case "delete":
          modelsLiquidation.commit("setOpenDelete", true);
          this.itemToDelete = item.liqmodelId;
          break;

        default:
          break;
      }
    },

    deleteItem() {
      modelsLiquidation.commit("setItemDelete", this.itemToDelete);
      modelsLiquidation
        .dispatch("delete")
        .then(() => {
          this.openDelete = false;
          modelsLiquidation.commit("setOpenDelete", false);
          this.showAlert(
            this.$tc("modelsLiquidations.deleteModelLiquidationSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(
            this.$tc("modelsLiquidations.deleteModelLiquidationError"),
            "#ff8d58"
          );
        });
    },

    cancelDelete() {
      this.openDelete = false;
      modelsLiquidation.commit("setOpenDelete", false);
    },
    openEditDialog() {
      this.$forceUpdate();
      this.showModelRelation = true;
    },

    closeEditDialog() {
      this.showModelRelation = false;
      configTable.commit("setColums", []);
      let nameTable = this.titleTable;
      configTable
        .dispatch("getColumsTableName", nameTable)
        .then(() => {
          if (configTable.state.colums.length === 0 || configTable.state.colums.length !== this.headers.length ) {
            this.saveConfigColumns();
          }
        })
        .catch((error) => {
          console.error("Error occurred:", error);
        });
    },
  },
};
</script>
